import { Theme } from '@oneamerica/dxp-ui-components';

const styles = (topInset: number) =>
  Theme.Responsive.create({
    infoHeader: {
      backgroundColor: Theme.Color.oaBlue,
    },
    header: {
      backgroundColor: Theme.Color.header.background,
      shadowColor: Theme.Color.ice2,
      shadowOffset: Theme.Color.shadow.shadowOffset,
      shadowOpacity: 0.4,
      shadowRadius: 3,
    },
    logo: {
      width: 159,
      height: 40,
    },
    guestText: {
      color: Theme.Color.text,
      fontSize: 14,
    },
    titleText: {
      color: Theme.Color.white,
      fontSize: 14,
    },
    companyText: {
      color: Theme.Color.white,
      fontSize: 12,
    },
    cursorPointer: {
      //@ts-ignore
      cursor: 'pointer',
    },
  })();

export default styles;
